import { Link } from 'react-router-dom';

import DropdownMenu from './DropdownMenu';
import Logout from '@/features/auth/components/Logout';
import NotificationsMenu from '@/client/features/notifications/Menu';
import { useAuth } from '@/hooks/useAuth';
import { LOW_QUOINS } from '@/constants';
import { formatCredits } from '@/features/usersettings/utils/formatCredits';

import UserIcon from '@/assets/icons/content/user.svg';
import CoinIcon from '@/assets/icons/topbar/coin.svg';
import DirectionIcon from '@/assets/icons/content/direction.svg';
import ChevronDown from '@/assets/icons/content/chevron-down.svg';

import classes from './Topbar.module.css';

const settingsTab = (tab: string) => `/settings?tab=${encodeURIComponent(tab)}`;

const getInitials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');

const ClientTopbarActions = () => {
  const { tokenInfo, userInfo, userInfoQuery } = useAuth();
  const creditsValue =
    userInfoQuery.isSuccess && userInfo?.quoins?.available != null
      ? Number(userInfo.quoins.available)
      : null;
  const creditsFormatted = formatCredits(creditsValue);
  const lowCredits =
    creditsValue != null && !Number.isNaN(creditsValue) && creditsValue <= LOW_QUOINS;
  const companyName = tokenInfo?.client_name?.trim() || 'Account';
  const userInitials =
    [tokenInfo?.first_name, tokenInfo?.last_name]
      .map((value) => value?.trim())
      .filter(Boolean)
      .slice(0, 2)
      .map((value) => value?.[0]?.toUpperCase() ?? '')
      .join('') ||
    getInitials(companyName) ||
    'A';
  const userName =
    [tokenInfo?.first_name, tokenInfo?.last_name].filter((value) => value?.trim()).join(' ') ||
    'User';

  return (
    <div className={classes.clientTopbarCluster}>
      <DropdownMenu
        icon={
          <div className={classes.accountTriggerContent}>
            <span className={classes.accountAvatar} aria-hidden>
              {userInitials}
            </span>

            <span className={classes.accountTriggerText}>
              <span className={classes.accountCompanyName}>{userName}</span>
              <span className={classes.accountUserName}>{companyName}</span>
            </span>

            <span className={classes.accountChevron} aria-hidden>
              <ChevronDown />
            </span>
          </div>
        }
        hideArrow
        size={280}
        appearance="moonPanel"
        triggerClassName={classes.accountTrigger}
      >
        <li className={classes.accountMenuItem}>
          <Link className={classes.accountMenuLink} to={settingsTab('profile')}>
            <span className={classes.accountMenuIcon} aria-hidden>
              <UserIcon />
            </span>
            My account
          </Link>
        </li>
        <li className={classes.accountMenuItem}>
          <Link className={classes.accountMenuLink} to="/transactions">
            <span
              className={`${classes.accountMenuIcon} ${classes.accountMenuCoinIcon}`}
              aria-hidden
            >
              <CoinIcon />
            </span>
            <span>
              Credits available
              <span
                className={`${classes.creditsValueNumber} ${lowCredits ? classes.creditsValueNumberLow : ''}`}
              >
                {'\u00A0'}
                {creditsFormatted}
              </span>
            </span>
          </Link>
        </li>
        <li className={classes.accountMenuItem}>
          <div className={classes.accountMenuLogoutWrap}>
            <span className={classes.accountMenuIcon} aria-hidden>
              <DirectionIcon />
            </span>
            <Logout />
          </div>
        </li>
      </DropdownMenu>
      <NotificationsMenu hideTriggerArrow />
    </div>
  );
};

export default ClientTopbarActions;
